import styled from '@emotion/styled';
import Checkbox from '__components/Inputs/CheckboxGroup/Checkbox';
import { KizenTypography } from '__app/typography';
import css from '@emotion/css';

export const StyledAutomationsGroupContent = styled.div<{ expanded: boolean }>`
  display: grid;
  transition: grid-template-rows 0.3s ease;
  ${({ expanded }) =>
    expanded
      ? css`
          grid-template-rows: 1fr;
        `
      : css`
          grid-template-rows: 0fr;
          pointer-events: none;
        `}
  margin-bottom: 15px;
  margin-left: 27px;
  /*  In case of long names we need to restrict the width to have enough space for right column tables */
  max-width: min(
    calc((100vw - var(--app-inset-right, 0px)) / 2 - 143px),
    calc(100vw - var(--app-inset-right, 0px) - 728px),
    604px
  );
`;

export const StyledAutomationsGroupContentInner = styled.div`
  min-height: 0;
  overflow: hidden;
`;

export const StyledAutomationFolderChildren = styled.div<{ expanded: boolean }>`
  display: grid;
  transition: grid-template-rows 0.3s ease;
  ${({ expanded }) =>
    expanded
      ? css`
          grid-template-rows: 1fr;
        `
      : css`
          grid-template-rows: 0fr;
          pointer-events: none;
        `}
`;

export const StyledAutomationFolderChildrenInner = styled.div`
  min-height: 0;
  overflow: hidden;
`;

export const StyledAutomationCheckbox = styled.div`
  height: 27px;
  display: flex;
  align-items: center;
  margin-bottom: 4px;
`;

export const StyledAutomationFolderCheckbox = styled(Checkbox)`
  max-width: calc(100% - 24px);
`;

export const StyledCounts = styled(KizenTypography)`
  flex-shrink: 0;
  margin-left: 4px;
`;
